"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createErrorMessage = createErrorMessage;
var _constants = require("../constants");
/**
 * A function that generates an error message based on provided error code and message parameters. It is used only internally.
 *
 * @param errorCode Error code.
 * @param errorMessages Object containing all possible error messages.
 * @param messageParameters Array of values that are used as message parameters.
 * @return Error message.
 */ function createErrorMessage(errorCode, errorMessages) {
    var messageParameters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var errorMessage = errorMessages[errorCode];
    if (!errorMessage) {
        return '';
    }
    return "".concat(errorCode, ": ").concat(errorMessage.replace(_constants.ERROR_MESSAGE_TOKEN_PATTERN, function(match, index) {
        return String(messageParameters[index]);
    }));
} //# sourceMappingURL=createErrorMessage.js.map
